import React from "react";
import "./possibility.css";

const possibilityImage = "/assets/img/arimg.webp";

const Possibility = () => (
  <section className="Scrobits__possibility section__padding" id="possibility">
    <div
      className="Scrobits__possibility-image"
      data-aos="zoom-in-right"
      data-aos-duration="1000"
    >
      <img src={possibilityImage} alt="Digital Possibilities with ScroBits" />
    </div>
    <div
      className="Scrobits__possibility-content"
      data-aos="zoom-out-right"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      {/* <h4>Request Early Access to Get Started</h4> */}
      <h1 className="gradient__text">
        Think Big <br /> We make IT, possible!
      </h1>
      <p>
      We help your organization accelerate digital transformation through 
      an integrated approach using open source tools, processes, and 
      strategies for measurable metrics-driven results.
      </p>
      {/* <h4>Request Early Access to Get Started</h4> */}
    </div>
  </section>
);

export default Possibility;
